<template>
  <el-dialog :title="'选择CBS银行流水关联现金：' + Number(payAmount || 0).toFixed(2) + ' 元'" :visible.sync="dialogVisible" width="90%" @close="cancel" :append-to-body="true">
    <!-- 筛选条件 -->
    <el-form :inline="true" size="small" style="margin-bottom: 15px;">
      <el-form-item label="查询时间">
        <el-date-picker
          v-model="flow_filter.timeRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          style="width: 240px;">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="银行账户">
        <el-input v-model="flow_filter.account_name" placeholder="请输入银行账户" clearable filterable style="width: 200px;"></el-input>
      </el-form-item>
      <el-form-item label="银行账号">
        <el-input v-model="flow_filter.account_no" placeholder="请输入银行账号" clearable filterable style="width: 200px;"></el-input>
      </el-form-item>
      <el-form-item label="银行类型">
        <el-select v-model="flow_filter.bank_type" placeholder="请选择" clearable filterable style="width: 150px;">
          <el-option
            v-for="item in bankTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发生额">
        <el-input v-model="flow_filter.incurred_amount" placeholder="请输入发生额" clearable filterable style="width: 200px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadCbsFlowList">查询</el-button>
        <el-button @click="resetFlowFilter">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 同步操作区 -->
    <el-divider content-position="left">同步操作区</el-divider>
    <el-form :inline="true" size="small" style="margin-bottom: 15px;">
      <el-form-item label="同步日期">
        <el-date-picker
          v-model="sync_date_range"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          style="width: 240px;">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="syncCbsFlow" :loading="syncing">同步数据</el-button>
      </el-form-item>
    </el-form>

    <!-- 流水表格 -->
    <el-table
      :data="cbs_flow_list"
      border
      stripe
      v-loading="cbs_flow_loading"
      height="400"
      highlight-current-row
      style="width: 100%;">
      <el-table-column label="选择" width="55" align="center">
        <template slot-scope="scope">
          <i
            v-if="selected_flows.length > 0 && selected_flows[0] === scope.row.id"
            class="el-icon-check"
            style="color: #67c23a; font-size: 18px; font-weight: bold; cursor: pointer;"
            @click="handleRowClick(scope.row)">
          </i>
          <i
            v-else
            class="el-icon-full-screen"
            style="color: #c0c4cc; font-size: 18px; cursor: pointer;"
            @click="handleRowClick(scope.row)">
          </i>
        </template>
      </el-table-column>
      <el-table-column prop="transaction_date" label="交易时间" width="160"></el-table-column>
      <el-table-column prop="account_name" label="银行账户" width="170"></el-table-column>
      <el-table-column prop="account_no" label="银行账号" width="180"></el-table-column>
      <el-table-column prop="opposite_name" label="对方户名" width="150"></el-table-column>
      <el-table-column prop="digest" label="摘要" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column label="发生额" width="120" align="right">
        <template slot-scope="scope">{{ scope.row.incurred_amount }}</template>
      </el-table-column>
      <el-table-column label="已勾兑" width="120" align="right">
        <template slot-scope="scope">{{ scope.row.reconciled_amount }}</template>
      </el-table-column>
      <el-table-column label="可用金额" width="120" align="right">
        <template slot-scope="scope">
          <span style="color: #67c23a; font-weight: bold;">
            {{ (parseFloat(scope.row.incurred_amount) - parseFloat(scope.row.reconciled_amount)).toFixed(2) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="银行流水" prop="bank_serial_number"></el-table-column>
      <el-table-column label="交易流水" prop="transaction_serial_number"></el-table-column>
      <el-table-column label="证明说明" width="150" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.prove_remark" style="color: #67c23a;">{{ scope.row.prove_remark }}</span>
          <span v-else style="color: #ccc;">-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
<!--          <el-link size="mini" type="primary" @click="openProveDialog(scope.row)">提交证明</el-link>-->
          <el-link size="mini" type="text" @click="viewFlowDetail(scope.row)">详情</el-link>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @current-change="handleCbsPageChange"
      :current-page.sync="cbs_pagination.page"
      :page-size="cbs_pagination.pageSize"
      :total="cbs_pagination.total"
      layout="total, prev, pager, next, jumper"
      style="margin-top: 20px; text-align: right;">
    </el-pagination>

    <!-- 底部提示和按钮 -->
    <div slot="footer" style="text-align: right;">
      <span style="margin-right: 20px;">已选流水总额: <strong style="color: #67c23a;">{{ selected_flow_total }}</strong></span>
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="confirmSelection">确定</el-button>
    </div>

    <!-- CBS流水详情组件 -->
    <cbs-flow-detail
      :visible.sync="flow_detail_visible"
      :flow-data="current_flow_row"
      @close="flow_detail_visible = false">
    </cbs-flow-detail>

    <!-- 证明提交弹框 -->
    <el-dialog title="提交证明" :visible.sync="prove_dialog_visible" width="600px" @close="closeProveDialog" :append-to-body="true">
      <el-form :model="prove_form" label-width="100px" size="small">
        <el-form-item label="证明说明" required>
          <el-input
            v-model="prove_form.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入证明说明">
          </el-input>
        </el-form-item>
        <el-form-item label="证明附件">
          <el-upload
            :http-request="handleProveUpload"
            action=""
            :show-file-list="true"
            :limit="1"
            :file-list="prove_file_list"
            list-type="text">
            <el-button size="small" type="primary" :loading="prove_uploading">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">支持jpg/png/pdf格式，大小不超过10M</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeProveDialog">取消</el-button>
        <el-button type="primary" @click="submitProve" :loading="prove_submitting">确定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import CbsFlowDetail from '../order/CbsFlowDetail.vue';
import ObjectStorage from '../../../../common/ObjectStorage';

export default {
  name: 'CbsFlowSelectorCash',
  props: {
    visible: { type: Boolean, default: false },
    pindexId: { type: [String, Number], default: 0 },
    payAmount: { type: Number, default: 0 }
  },
  data() {
    return {
      dialogVisible: false,
      selected_flows: [],
      cbs_flow_list: [],
      cbs_flow_loading: false,
      sync_date_range: [],
      syncing: false,
      flow_filter: {
        timeRange: [],
        account_no: '',
        bank_type: ''
      },
      cbs_pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      bankTypeOptions: [],
      flow_detail_visible: false,
      current_flow_row: null,
      // 证明提交相关
      prove_dialog_visible: false,
      prove_submitting: false,
      prove_uploading: false,
      prove_form: {
        remark: '',
        file_path: ''
      },
      prove_file_list: [],
      prove_current_row: null,
      prove_bucket_name: 'gdza'
    };
  },
  computed: {
    selected_flow_total() {
      if (!this.selected_flows || this.selected_flows.length === 0) {
        return 0;
      }
      const flowId = this.selected_flows[0];
      const flow = this.cbs_flow_list.find(f => f.id === flowId);
      if (flow) {
        return (parseFloat(flow.incurred_amount) - parseFloat(flow.reconciled_amount)).toFixed(2);
      }
      return 0;
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        // 弹框关闭时清空数据
        this.selected_flows = [];
        this.cbs_flow_list = [];
        this.resetFlowFilter();
        this.dialogVisible = false;
      } else {
        // 打开时先设置dialogVisible为true
        this.dialogVisible = true;
        // 加载银行类型列表
        if (this.bankTypeOptions.length === 0) {
          this.loadBankTypeList();
        }
        // 加载流水列表
        this.loadCbsFlowList();
      }
    }
  },
  methods: {
    // 加载银行类型列表
    loadBankTypeList() {
      this.$myhttp.post('admin/cbsBankType', {}, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        if (res.data.code === 200) {
          this.bankTypeOptions = res.data.data || [];
        }
      }).catch(err => {
        console.error('加载银行类型列表异常:', err);
      });
    },
    // 加载可用流水列表
    loadCbsFlowList() {
      this.cbs_flow_loading = true;

      let startDate = undefined;
      let endDate = undefined;
      if (this.flow_filter.timeRange && this.flow_filter.timeRange.length === 2) {
        startDate = this.flow_filter.timeRange[0] + ' 00:00:00';
        endDate = this.flow_filter.timeRange[1] + ' 23:59:59';
      }

      const params = {
        pindex_id: this.pindexId,
        page: this.cbs_pagination.page,
        pageSize: this.cbs_pagination.pageSize,
        account_name: this.flow_filter.account_name || undefined,
        account_no: this.flow_filter.account_no || undefined,
        bank_type: this.flow_filter.bank_type || undefined,
        incurred_amount: this.flow_filter.incurred_amount || undefined,
        start_date: startDate,
        end_date: endDate
      };

      this.$myhttp.post('admin/cbs/getAvailableFlowList', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        this.cbs_flow_loading = false;
        if (res.data.code === 200) {
          this.cbs_flow_list = res.data.data.list || [];
          this.cbs_pagination.total = res.data.data.total || 0;
        } else {
          this.$message.error(res.data.message || '查询失败');
        }
      }).catch(err => {
        this.cbs_flow_loading = false;
        this.$message.error('请求异常');
        console.error(err);
      });
    },
    // 重置流水筛选条件
    resetFlowFilter() {
      this.flow_filter.timeRange = [];
      this.flow_filter.account_no = '';
      this.flow_filter.bank_type = '';
      this.cbs_pagination.page = 1;
    },
    // 处理行点击选择
    handleRowClick(row) {
      console.log(row)
      // 检查是否有证明说明
      // if (!row.prove_remark) {
      //   this.$message.warning('请先提交证明说明后再选择该流水');
      //   return;
      // }

      if (this.selected_flows.length > 1) {
        this.$message.warning('只能选择一个');
        return;
      }

      if (this.selected_flows.length > 0 && this.selected_flows[0] === row.id) {
        this.selected_flows = [];
      } else {
        this.selected_flows = [row.id];
      }
      console.log('selected_flows',this.selected_flows);
    },
    // 同步CBS流水
    syncCbsFlow() {
      if (!this.sync_date_range || this.sync_date_range.length !== 2) {
        this.$message.warning('请选择同步日期范围');
        return;
      }

      this.syncing = true;
      const params = {
        start_date: this.sync_date_range[0],
        end_date: this.sync_date_range[1],
        pindex_id: this.pindexId
      };

      this.$myhttp.post('admin/cbs/syncFlowByDate', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        this.syncing = false;
        if (res.data.code === 200) {
          this.$message.success(res.data.message || '同步成功');
          this.loadCbsFlowList();
        } else {
          this.$message.error(res.data.message || '同步失败');
        }
      }).catch(err => {
        this.syncing = false;
        this.$message.error('请求异常');
        console.error(err);
      });
    },
    // 查看流水详情
    viewFlowDetail(row) {
      this.current_flow_row = row;
      this.flow_detail_visible = true;
    },
    // 确认流水选择
    confirmSelection() {
      if (this.selected_flows.length === 0) {
        this.$message.warning('请至少选择一条流水');
        return;
      }

      const flowId = this.selected_flows[0];
      const flow = this.cbs_flow_list.find(f => f.id === flowId);

      if (!flow) {
        this.$message.error('流水数据异常');
        return;
      }

      const availableAmount = Math.round((parseFloat(flow.incurred_amount) - parseFloat(flow.reconciled_amount)) * 100) / 100;
      const payAmount = Math.round(this.payAmount * 100) / 100;
      if (availableAmount != payAmount) {
        this.$message.warning(`可用金额(${availableAmount.toFixed(2)})不等于存入金额(${payAmount.toFixed(2)})`);
        return;
      }

      // 同时返回flowId和完整flow数据
      this.$emit('confirm', flowId, flow);
      this.dialogVisible = false;
    },
    // CBS流水分页切换
    handleCbsPageChange(page) {
      this.cbs_pagination.page = page;
      this.loadCbsFlowList();
    },
    // 取消
    cancel(){
      this.dialogVisible = false;
      this.$emit('close');
    },
    // 打开证明提交弹框
    openProveDialog(row) {
      this.prove_current_row = row;
      this.prove_form.remark = '';
      this.prove_form.file_path = '';
      this.prove_file_list = [];
      this.prove_dialog_visible = true;
    },
    // 关闭证明提交弹框
    closeProveDialog() {
      this.prove_dialog_visible = false;
      this.prove_current_row = null;
      this.prove_form.remark = '';
      this.prove_form.file_path = '';
      this.prove_file_list = [];
    },
    // 使用ObjectStorage上传文件
    handleProveUpload(params) {
      this.prove_uploading = true;
      const file = params.file;

      // 校验文件类型
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isPDF = file.type === 'application/pdf';
      const isValidType = isJPG || isPNG || isPDF;

      if (!isValidType) {
        this.$message.error('只能上传jpg/png/pdf格式的文件!');
        this.prove_uploading = false;
        return;
      }

      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过10MB!');
        this.prove_uploading = false;
        return;
      }

      // 使用ObjectStorage上传
      ObjectStorage.getOssConfig(config => {
        const oss = new ObjectStorage(config);
        oss.setBucket(this.prove_bucket_name);

        const date = new Date();
        const date_path = date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate() + '/';
        const objectKey = date_path + file.name;

        oss.upload(file, objectKey, (res) => {
          this.prove_uploading = false;
          if (res && res.path) {
            this.prove_form.file_path = res.path;
            this.prove_file_list = [{
              name: file.name,
              url: res.path
            }];
            this.$message.success('文件上传成功');
          } else {
            this.$message.error('文件上传失败');
            this.prove_file_list = [];
          }
        });
      });
    },
    // 提交证明
    submitProve() {
      if (!this.prove_form.remark) {
        this.$message.warning('请输入证明说明');
        return;
      }

      if (!this.prove_current_row) {
        this.$message.error('数据异常');
        return;
      }

      this.prove_submitting = true;
      const formData = new FormData();
      formData.append('flow_id', this.prove_current_row.id);
      formData.append('prove_remark', this.prove_form.remark);

      // 文件已经上传到OSS，直接发送路径
      if (this.prove_form.file_path) {
        formData.append('prove_files', this.prove_form.file_path);
      }

      this.$myhttp.post('admin/cbs/saveFlowProof', formData, {
        'Content-Type': 'multipart/form-data'
      }).then(res => {
        this.prove_submitting = false;
        if (res.data.code === 200) {
          this.$message.success('提交成功');
          this.closeProveDialog();
          this.loadCbsFlowList(); // 刷新列表
        } else {
          this.$message.error(res.data.message || '提交失败');
        }
      }).catch(err => {
        this.prove_submitting = false;
        this.$message.error('请求异常');
        console.error(err);
      });
    },
    // 查看证明详情
    viewProveDetail(row) {
      this.current_flow_row = row;
      this.flow_detail_visible = true;
    }
  },
  components: {
    CbsFlowDetail
  }
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/component/CbsFlowSelectorCash.vue